export default [
  {
    title: 'Battery size and range',
    content:
      'A larger battery can provide a longer range, but factors such as vehicle weight, temperature and driving conditions can influence range'
  },
  {
    title: 'Vehicle history',
    content:
      'Check the vehicle’s CarFax® or AutoCheck® report to assess the car’s condition'
  },
  {
    title: 'Mileage',
    content:
      'Be cautious of high-mileage EVs, as battery degradation may be more significant'
  },
  {
    title: 'Charging infrastructure',
    content:
      'Research the availability and costs of charging stations in your area'
  },
  {
    title: 'Inspection',
    content: 'Check the inspection report to uncover any potential issues'
  }
];
